import axios from 'axios';

// Base URL for API - Change this based on your environment
// export const BASE_URL = 'http://localhost:50000/api/v1';
export const BASE_URL = 'https://backend.diraminds.com/api/v1';

// Create axios instance with default config
const apiClient = axios.create({
  baseURL: BASE_URL,
  timeout: 30000,
  headers: {
    'Content-Type': 'application/json',
  },
});

// Request interceptor - Add auth token to requests
apiClient.interceptors.request.use(
  (config) => {
    // For cookie-based auth, we don't need to manually add headers
    // The browser will automatically include cookies
    config.withCredentials = true; // Important for cookie-based auth

    // If the data is FormData, remove the default Content-Type header
    // so axios can set the correct multipart/form-data boundary
    if (config.data instanceof FormData) {
      console.log('FormData detected - removing Content-Type header');
      delete config.headers['Content-Type'];
      console.log('Headers after FormData processing:', config.headers);
    }

    return config;
  },
  (error) => {
    return Promise.reject(error);
  }
);

// Response interceptor - Handle errors globally
apiClient.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response) {
      // Handle specific error codes
      switch (error.response.status) {
        case 401:
          // Unauthorized - Clear user data and redirect to login
          localStorage.removeItem('dira-user');
          window.location.href = '/login';
          break;
        case 403:
          // Forbidden
          console.error('Access forbidden');
          break;
        case 404:
          // Not found
          console.error('Resource not found');
          break;
        case 500:
          // Server error
          console.error('Server error occurred');
          break;
        default:
          console.error('An error occurred:', error.response.data);
      }
    } else if (error.request) {
      // Network error
      console.error('Network error - Please check your connection');
    } else {
      console.error('Error:', error.message);
    }
    return Promise.reject(error);
  }
);

export default apiClient;

